import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Page } from "@/components";
import { nyBestillingConfig } from "@/features/bestillinger/config/nyBestillingConfig";
import {
  deletePersistantState,
  getPersistantState,
} from "@/features/bestillinger/hooks";
import { BestillingStepper } from "@/features/navigation";
import { cn } from "@/utils";

const resetNyBestilling = async (ctx: { location: { pathname: string } }) => {
  if (ctx.location.pathname === "/bestilling/ny") {
    deletePersistantState(
      nyBestillingConfig.storageKey,
      nyBestillingConfig.storageType,
    );
    throw redirect({
      to: "/bestilling/ny/informasjon",
      replace: true,
      // #18543
      // form state in BestillingContext can become out of sync with persisted state in session storage
      // reload document to ensure everything is in sync
      reloadDocument: true,
    });
  }
  // If a user tries to go back after placing an order
  // They should be redirected to the start of the flow
  const bestilling =
    getPersistantState(
      nyBestillingConfig.storageKey,
      nyBestillingConfig.storageType,
    ) || {};
  const leverandoerOrgNr = bestilling.leverandoerOrgNr;

  if (
    ctx.location.pathname !== "/bestilling/ny/informasjon" &&
    ctx.location.pathname !== "/bestilling/ny/finn-leverandoer" &&
    !leverandoerOrgNr
  ) {
    throw redirect({
      to: "/bestilling/ny/informasjon",
      replace: true,
    });
  }
};
export const Route = createFileRoute("/_app/bestilling/ny")({
  loader: resetNyBestilling,
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "Ny bestilling | Norgespris for Fjernvarme",
      },
    ],
  }),
});

function RouteComponent() {
  return (
    <div className={cn("lg:flex-1 flex flex-col lg:flex-row stretch")}>
      <Page className="w-full flex-1 min-h-fit" withBackLink>
        <BestillingStepper />
        <Outlet />
      </Page>
    </div>
  );
}
